import React from 'react';
import { Box, Typography, Paper, IconButton } from '@mui/material';
import { Group, Edit } from '@mui/icons-material';
import { CommitteeInfoCardProps } from './types';

const CommitteeInfoCard = ({
  comitee,
  onEditClick,
  canEdit,
}: CommitteeInfoCardProps) => {
  const hasCommittee = comitee && comitee.name;
  const mainColor = hasCommittee ? 'primary.main' : 'warning.main';
  const backgroundColor = hasCommittee
    ? 'rgba(25, 118, 210, 0.08)'
    : 'rgba(255, 152, 0, 0.08)';
  return (
    <Paper
      sx={{
        p: 2,
        mb: 2,
        boxShadow: 'none',
        border: '1px solid #e0e0e0',
        backgroundColor: '#fafafa',
        position: 'relative',
        borderRadius: '8px',
      }}
    >
      {canEdit && onEditClick && (
        <IconButton
          onClick={onEditClick}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            backgroundColor: backgroundColor,
            '&:hover': {
              backgroundColor: backgroundColor,
            },
          }}
          size="small"
        >
          <Edit
            sx={{
              fontSize: '1rem',
              color: hasCommittee ? 'primary.main' : 'warning.main',
            }}
          />
        </IconButton>
      )}

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
        <Box
          sx={{
            backgroundColor: backgroundColor,
            borderRadius: '50%',
            p: 0.75,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Group
            sx={{
              fontSize: '1rem',
              color: mainColor,
            }}
          />
        </Box>
        <Box>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 700,
              lineHeight: 1,
              fontSize: '1.1rem',
              color: mainColor,
            }}
          >
            {hasCommittee ? comitee.name : 'Sin comité asignado'}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              fontSize: '0.8rem',
              lineHeight: 1,
            }}
          >
            {hasCommittee ? 'Comité de Aprobación' : 'Estado del comité'}
          </Typography>
        </Box>
      </Box>

      <Typography
        variant="body2"
        sx={{ color: 'text.secondary', lineHeight: 1.4 }}
      >
        {hasCommittee
          ? 'Este comité es responsable de revisar y aprobar las solicitudes según los criterios establecidos. Cada rol debe ser aprobado por los usuarios correspondientes.'
          : 'No se ha asignado un comité a esta solicitud. Una vez asignado, podrás ver los roles requeridos y el estado de las aprobaciones. El comité será asignado automáticamente según los criterios de la solicitud y los roles disponibles en el sistema.'}
      </Typography>
    </Paper>
  );
};

export default CommitteeInfoCard;
